// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"styles_footerContent__j7gUc","footerSection":"styles_footerSection__Mep9l"};